import { render, staticRenderFns } from "./LicitacaoVisualizacaoAcoes.vue?vue&type=template&id=a0f9b2b2&scoped=true&"
import script from "./LicitacaoVisualizacaoAcoes.vue?vue&type=script&lang=js&"
export * from "./LicitacaoVisualizacaoAcoes.vue?vue&type=script&lang=js&"
import style0 from "./LicitacaoVisualizacaoAcoes.vue?vue&type=style&index=0&id=a0f9b2b2&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f9b2b2",
  null
  
)

export default component.exports